export const ACCOUNT_BUSINESS_REGISTRATION_NUMBER_TYPE = Object.freeze({
  USA_EIN: 'USA: Employer Identification Number (EIN)',
  USA_DUNS: 'USA: DUNS Number (Dun & Bradstreet)',
  CANADA_BIN: 'Canada: Business Number (BIN)',
  GB_COMPANY_NUMBER: 'Great Britain: Company Number',
  AUS_ASIC: 'Australia: Company Number from ASIC (ACN)',
  INDIA_CIN: 'India: Corporate Identity Number',
  EST_VAT: 'Estonia: VAT Number',
  ROM_VAT: 'Romania: VAT Registration Number',
  ISRAEL_REGISTRATION_NUMBER: 'Israel: Registration Number',
  OTHER: 'Other',
});
